export default __webpack_public_path__ + "static/media/quick-pay.4170bd41.svg";